import * as React from "react"
import {ErrorField} from "./app"
import {Modal} from "../../../lib/sbhtml/modal";
import {Form} from "../../../lib/sbhtml/form"
import {Input} from "../../../lib/sbhtml/input"
import {Checkbox} from "../../../lib/sbhtml/checkbox"
import {Textarea} from "../../../lib/sbhtml/textarea"

export type SubscriptionAppValueProps = {
	name:string
	optional:boolean
	reason:string
	isSaving:boolean
	errorFields?:ErrorField[]
}

export type SubscriptionAppCallbackProps = {
	nameOnChange:(newName:string) => void
	optionalOnChange:(newOptional:boolean) => void
	reasonOnChange:(newReason:string) => void
	onClose:() => void
	onSave:() => void
}

const SubscriptionForm = (props:SubscriptionAppValueProps & SubscriptionAppCallbackProps) => {
	const nameErrors = props.errorFields !== undefined ? props.errorFields.filter((e) => e.fieldType == 'name') : []
	return <div>
		<Form hasSave={true} hasCancel={true} onCancel={props.onClose} onSubmit={props.onSave} isSubmitting={props.isSaving}>
			<label><p>Name: </p>
				<Input style={{width: "95%"}} value={props.name} onChange={(value) => props.nameOnChange(value)} invalid={nameErrors.length > 0} />
			</label>
			{nameErrors.length > 0 &&
			<ul>{nameErrors.map((e) => <li style={{color: "red"}}><p style={{color: "red"}}>{e.errorMessage}</p></li>)}</ul>
			}
			<label><p>Optional: </p>
				<Checkbox checked={props.optional} value='1' onChange={(value) => props.optionalOnChange(value)} />
			</label>
			{!props.optional &&
			<label><p>Unsubscribe Reason: </p>
				<Textarea style={{width: "95%"}} value={props.reason} onChange={(value) => props.reasonOnChange(value)} />
			</label>
			}
		</Form>
	</div>
}

export const SubscriptionApp = (props:SubscriptionAppValueProps & SubscriptionAppCallbackProps) => <div>
	<Modal style={{width: "40em"}} isOpen={true} title="Add Subscription" onRequestClose={props.onClose}>
		<SubscriptionForm {...props}/>
	</Modal>
</div>



// WEBPACK FOOTER //
// ./src/subscriptionmanager/module/subscription-list/presentation.tsx